import { FACE_NAMES } from "./constants"
import { ExperienceRating } from "./types"

export const getTabIndex = (
  index: number,
  faceType: ExperienceRating,
  focusedIndex: number,
  selectedRate: ExperienceRating,
  disabled: boolean
): number => {
  if (disabled) return -1
  // If we're actively navigating, the focused index is tabbable
  if (focusedIndex >= 0) {
    return focusedIndex === index ? 0 : -1
  }
  // If a face is selected, only that one is tabbable
  if (selectedRate) {
    return selectedRate === faceType ? 0 : -1
  }
  // If none selected, first radio is tabbable
  return index === 0 ? 0 : -1
}

export const getNextIndex = (
  key: string,
  currentIndex: number
): number | null => {
  if (key === "ArrowRight" || key === "ArrowDown") {
    return (currentIndex + 1) % FACE_NAMES.length
  }
  if (key === "ArrowLeft" || key === "ArrowUp") {
    return (currentIndex - 1 + FACE_NAMES.length) % FACE_NAMES.length
  }
  return null
}
